import { render, staticRenderFns } from "./ContactModal.vue?vue&type=template&id=98e0cb12&scoped=true"
import script from "./ContactModal.vue?vue&type=script&lang=js"
export * from "./ContactModal.vue?vue&type=script&lang=js"
import style0 from "./ContactModal.vue?vue&type=style&index=0&id=98e0cb12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e0cb12",
  null
  
)

export default component.exports